// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "@firebase/functions"
import { collection, connectFirestoreEmulator, getDocs, getFirestore, setDoc } from "firebase/firestore"
import { connectAuthEmulator, getAuth, signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, onAuthStateChanged, UserInfo } from "firebase/auth"
import { Blog } from "../Pages/BlogPage/loadBlogs";
import { useEffect, useState } from "react";
import { https } from "firebase-functions/v1";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCl2yWyg7O4YiIo3bJPco78CO21D86-X34",
    authDomain: "moleszkf-1c99a.firebaseapp.com",
    projectId: "moleszkf-1c99a",
    storageBucket: "moleszkf-1c99a.appspot.com",
    messagingSenderId: "386829055539",
    appId: "1:386829055539:web:8ba4e4a9049db7b7e69546",
    measurementId: "G-ZHC8EC7H69"
};
const isDev = window.location.hostname === "localhost";
// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);



export async function initFirebase() {
    if (isDev) {
        connectAuthEmulator(getAuth(app), 'http://localhost:9099');

        connectFunctionsEmulator(getFunctions(app), "localhost", 5001);
        connectFirestoreEmulator(getFirestore(app), "localhost", 8080);
        ; (window as any).logout = () => logout();
        ; (window as any).login = (email: string, pass: string) => login(email, pass);

    }
}
export type contactMe = {
    name: string,
    email: string,
    msg: string
}
export async function contactWithMe(data: contactMe) {
    return httpsCallable(getFunctions(app), "contactWithMe")(data);
}

export type BlogType = {
    id:number,
    title: string,
    content: string,
    date: string
}
export async function addBlogToFirestore(data: BlogType){
    return httpsCallable(getFunctions(app),"addBlog")(data)
}
export async function getBlogs(): Promise<Blog[]> {
    const blogDocs = await getDocs(collection(getFirestore(app), "blogs"))
    const blogs: Blog[] = [];
    for (const b of blogDocs.docs) {
        const nb: Blog = {
            id: b.get("id"),
            title: b.get("title"),
            content: b.get("content"),
            date: b.get("date")
        }
        blogs.push(nb);
    };
    return blogs
}

export async function addBlog() {
    const titleElement = document.getElementById("title") as HTMLInputElement;
    const title = titleElement.value;
    const contentElement = document.getElementById("writer-blog") as HTMLInputElement;
    const content = contentElement.value;

    if(title === "" || content === ""){
        console.log("%c Title or content is empty!", "color:red; font-weight: bolder;")
        return
    }
    const date = new Date()
    const parsedDate = `${date.getFullYear()}-${date.getMonth()}-${date.getDay()}`
    const lastIndex = (await getBlogs()).length
    const formData :BlogType = {
        id: lastIndex+1,
        title: title,
        content: content,
        date: parsedDate
    }
    await addBlogToFirestore(formData)

}



export function useUsers(): boolean {
    const [logged, setLogged] = useState<boolean>(false)
    useEffect(() => {
        onAuthStateChanged(getAuth(app), (user_) => {
            setLogged(() => user_ ? true : false)
        })
    }, [])

    return logged
}
export function getUID() {
}

export async function login(email: string, pass: string) {
    await signInWithEmailAndPassword(getAuth(app), email, pass);
}
export async function register(email: string, password: string) {
    await createUserWithEmailAndPassword(getAuth(app), email, password)
}
export async function logout() {
    await signOut(getAuth(app));
}
